import React from "react";

const AdvancedManagementInfoStep = ({ dataImg, dataText, children } = props) => {
	return (
		<div className="advanced-management-info-step">
			<img src={dataImg} alt="Info step image" />
			{dataText}
			{children}
		</div>
	);
};

export default AdvancedManagementInfoStep;
